import { OutboxProcessorService } from './outbox-processor.service';

import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { liveQuery } from 'dexie';
import { db } from '../db/offline-database';

@Injectable({ providedIn: 'root' })
export class OutboxService {

    constructor(
        private outboxProcessorService: OutboxProcessorService
    ){

    }

    readonly count$: Observable<number> = from(liveQuery(() => db.outbox.count()));
    deleteQueue(): Promise<void> { return db.outbox.clear(); }

    sync(): Promise<void> { return this.outboxProcessorService.drain(); }

    getOnce(): Promise<number> { return db.outbox.count(); }
}
